import { Alert, Snackbar } from "@mui/material";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  selectSnackbar,
  showSnackbar,
} from "src/store/reducers/navigation/navigationSlice";

const RFSnackbar = () => {
  const { open, message, type } = useAppSelector(selectSnackbar);

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(showSnackbar({ open: false, message: "", type: "warning" }));
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 2,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <Alert
        onClose={handleClose}
        severity={type || "success"}
        variant="filled"
        sx={{
          width: "100%",
          fontWeight: 500,
          alignItems: "center",
          ...(type === "success" && {
            backgroundColor: "#4CAF50",
            color: "white",
          }),
          ...(type === "error" && {
            backgroundColor: "#F44336",
            color: "white",
          }),
          ...(type === "warning" && {
            backgroundColor: "#FF9800",
            color: "white",
          }),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default RFSnackbar;
